var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
var LineCancelComponent = /** @class */ (function () {
    function LineCancelComponent(router, route, http) {
        this.router = router;
        this.route = route;
        this.http = http;
        this.email = '';
        this.password = '';
        this.lineUserId = '';
        this.showCompletionMessage = false;
        this.isLoading = true;
        this.errorMessage = '';
        this.isLineClient = false;
    }
    LineCancelComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var profile, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        // LIFF初期化
                        console.log('LIFF初期化を開始します...');
                        return [4 /*yield*/, liff.init({ liffId: environment.lineCancelLiffId })];
                    case 1:
                        _a.sent();
                        console.log('LIFF初期化完了');
                        if (!liff.isLoggedIn()) return [3 /*break*/, 3];
                        return [4 /*yield*/, liff.getProfile()];
                    case 2:
                        profile = _a.sent();
                        this.lineUserId = profile.userId;
                        console.log('LINE ID取得完了:', this.lineUserId);
                        this.isLoading = false;
                        return [3 /*break*/, 4];
                    case 3:
                        // 未ログインの場合、ログイン処理を実行
                        console.log('LINEログインを開始します');
                        liff.login();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        console.error('LIFFエラー詳細:', err_1);
                        this.errorMessage = "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: " + (err_1.message || '不明なエラー');
                        this.isLoading = false;
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LineCancelComponent.prototype.cancelLine = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.email || !this.password) {
                            alert('メールアドレスとパスワードを入力してください');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(environment.apiUrl + "/api/v1/line/cancel", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    email: this.email,
                                    password: this.password,
                                    lineUserId: this.lineUserId
                                })
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('認証エラー');
                        }
                        // 成功時のみ完了メッセージを表示
                        this.showCompletionMessage = true;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // アラートを表示
                        alert('LINE連携解除に失敗しました。メールアドレスとパスワードを確認してください。');
                        // エラーメッセージを設定
                        this.errorMessage = 'メールアドレスまたはパスワードが正しくありません';
                        // パスワードのみをクリア
                        this.password = '';
                        // エラーをコンソールに出力
                        console.error('LINE連携解除エラー:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return LineCancelComponent;
}());
export { LineCancelComponent };
